import { render, staticRenderFns } from "./authentication-history.vue?vue&type=template&id=88add290&"
import script from "./authentication-history.vue?vue&type=script&lang=js&"
export * from "./authentication-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports